import styled, { css } from 'styled-components';
import ArrowCTAIcon from './ArrowCTAIcon';

const AnimationWrapper = styled.span`
  height: ${({ height }) => height ?? 16}px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;

  &:hover .arrowAnimated svg {
    transform: translateX(6px);
  }
  svg {
    ${({ color }) => css`
      color: ${color};
    `};
    transition: all 0.3s ease-in-out;
    transform: translateX(0);
  }
`;

/**
 * @param {Object} props
 * @param {boolean} [props.hovered]
 * @param {boolean} [props.checked]
 * @param {string | undefined} [props.color]
 * @param {number | undefined} [props.height]
 * @param {number | undefined} [props.width]
 * @returns {React.ReactElement} The rendered component
 */
const ArrowCTAAnimationIcon = ({ hovered, checked, color, height, width }) => (
  <AnimationWrapper
    hovered={hovered || checked}
    className={'arrowAnimated'}
    color={color}
    height={height}
    data-id="arrow-cta-animation-icon-wrapper"
  >
    <ArrowCTAIcon
      height={height}
      width={width}
      data-id="arrow-cta-animation-icon"
    />
  </AnimationWrapper>
);

export default ArrowCTAAnimationIcon;
